import TeamFilter from "components/form_components/TeamFilter";
import { BidFilterContentProps, StyledFilterContent } from "./utils";

function TeamFilterContent({ control }: BidFilterContentProps) {
  return (
    <StyledFilterContent aria-label="Team filter">
      <TeamFilter control={control} name="teamIds" label="" />
    </StyledFilterContent>
  );
}

export default TeamFilterContent;
